"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestQuoteForm = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var component_library_waas_templates_base_input_1 = require("@tradesorg/component-library-waas-templates.base-input");

var component_library_waas_templates_base_button_1 = require("@tradesorg/component-library-waas-templates.base-button");

function RequestQuoteForm(_ref) {
  var background = _ref.background,
      position = _ref.position,
      btnTemplate = _ref.btnTemplate,
      btnText = _ref.btnText,
      values = _ref.values,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      className = _ref.className,
      errorMessage = _ref.errorMessage,
      isLoading = _ref.isLoading;
  return react_1.default.createElement("div", {
    className: "flex ".concat(position === 'vertical' ? 'flex-col justify-between gap-4' : 'items-baseline gap-4', "  ").concat(background === true ? 'bg-white' : '', " ").concat(className === null || className === void 0 ? void 0 : className.wrapper)
  }, react_1.default.createElement("div", {
    className: "".concat(position === 'horizontal' ? 'w-1/3' : '')
  }, react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    type: "text",
    name: "name",
    placeholder: "Your name",
    value: values === null || values === void 0 ? void 0 : values.name,
    onChange: onChange
  })), react_1.default.createElement("div", {
    className: "".concat(position === 'horizontal' ? 'w-1/3' : '')
  }, react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    name: "phone",
    placeholder: "Your phone",
    value: values === null || values === void 0 ? void 0 : values.phone,
    onChange: onChange
  })), react_1.default.createElement("div", {
    className: "".concat(position === 'horizontal' ? 'w-1/3' : '')
  }, react_1.default.createElement(component_library_waas_templates_base_input_1.Input, {
    type: "email",
    name: "email",
    placeholder: "Your email address",
    value: values === null || values === void 0 ? void 0 : values.email,
    onChange: onChange
  })), errorMessage && react_1.default.createElement("div", {
    className: "my-4 text-red-700"
  }, errorMessage), react_1.default.createElement(component_library_waas_templates_base_button_1.Button, {
    onClick: onSubmit,
    template: btnTemplate
  }, isLoading ? "Sending..." : btnText));
}

exports.RequestQuoteForm = RequestQuoteForm;
RequestQuoteForm.propTypes = {
  background: prop_types_1.default.bool,
  position: prop_types_1.default.string,
  btnTemplate: prop_types_1.default.number,
  btnText: prop_types_1.default.string,
  values: prop_types_1.default.object,
  onSubmit: prop_types_1.default.func,
  onChange: prop_types_1.default.func,
  className: prop_types_1.default.object
};
RequestQuoteForm.defaultProps = {
  background: false,
  position: 'vertical',
  btnTemplate: 3,
  btnText: 'Button'
};